import * as React from 'react'
import {mmap} from '@freckle/maybe'

import {type DistrictT} from '@frontrow/console/src/models/district'
import {dateAccessor} from '@frontrow/console/src/helpers/formatters'
// Components
import {
  Field,
  FIELD_GRID_HALF
} from '@frontrow/console/src/components/pages/teachers-page/teacher-information-button-modal/field'

type Props = {
  district: DistrictT
}

export default function DistrictInformation(props: Props): React.ReactElement {
  const {district} = props

  const {id, name, createdAt, classLinkDistrictId, cleverDistrictId, formattedAddressLines} =
    district

  return (
    <div className={FIELD_GRID_HALF}>
      <Field name="Id" value={id} />
      <Field name="Name" value={name} />
      <Field name="Created At" value={dateAccessor(createdAt)} />
      <Field
        name="Address Lines"
        value={mmap(f => f.map((a, i) => <p key={i}>{a}</p>), formattedAddressLines)}
      />
      <Field name="ClassLink District Id" value={classLinkDistrictId} />
      <Field name="Clever District Id" value={cleverDistrictId} />
    </div>
  )
}
